(function () {
  /**
   * @awaitingdeprecation
   */
  angular
    .module('binky.core.directories')
    .constant('DIRECTORY_LIST_CACHE_ID', 'DirectoryList')
    .constant('DIRECTORY_LIST_EVENT', {
      UPDATE: 'UpdateDirectoryList',
      UPDATE_COUNT: 'UpdateDirectoriesCount',
    });
})();
